import ChiefBalancingWindow from './chief-balancing-window'

export default ChiefBalancingWindow
